// Usunięcie załącznika z wątku czatu

import { orionAxios } from '../orionApi';

/**
 * Usuwa załącznik z wątku czatu
 * @param threadId - UUID wątku
 * @param attachmentId - UUID załącznika
 */
export const removeAttachment = async (threadId: string, attachmentId: string): Promise<void> => {
  await orionAxios.delete(
    `/api/aiassistant/remove-attachment/${threadId}/${encodeURIComponent(attachmentId)}`
  );
};

